/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_4_AInputs */

const en_pc_faq_4_a = /** @type {(inputs: Pc_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. It reads and writes layered PSD and PSB files with groups, masks, type, smart objects and layer styles. Re-saved files are not byte-identical, but nearly all of the project's test files render the same.`)
};

const zh_pc_faq_4_a = /** @type {(inputs: Pc_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。它能读写分层 PSD 和 PSB，包括图层组、蒙版、文字、智能对象和图层样式。重新保存的文件并非逐字节相同，但项目的测试文件几乎全部渲染一致。`)
};

/**
* | output |
* | --- |
* | "Yes. It reads and writes layered PSD and PSB files with groups, masks, type, smart objects and layer styles. Re-saved files are not byte-identical, but nearl..." |
*
* @param {Pc_Faq_4_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_4_a = /** @type {((inputs?: Pc_Faq_4_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_4_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_4_a(inputs)
	return zh_pc_faq_4_a(inputs)
});
export { pc_faq_4_a as "pc.faq.4.a" }